module.exports = __webpack_public_path__ + "img/logo2.f36df97f.png";